module.exports = "/_next/static/images/easyjet-ffc6c0af1aadb48f5f32f1a63bfd7680.svg";